import React, { useState } from "react";
import { ChevronRight, ChevronLeft } from "lucide-react";
import { PartnerUniversityProps } from "../../Data/Partners";

interface PartnerCardProps {
  partners: PartnerUniversityProps[];
}

export default function PartnerCard({ partners }: PartnerCardProps) {
  const [activeTab, setActiveTab] = useState(0);
  const [startIndex, setStartIndex] = useState(0); // Start of current page of headers
  const [isFading, setIsFading] = useState(false);
  const tabsPerPage = 6;
  const total = partners.length;

  const handlePrev = () => {
    setStartIndex((prev) => Math.max(prev - tabsPerPage, 0));
  };

  const handleNext = () => {
    setStartIndex((prev) =>
      Math.min(prev + tabsPerPage, total - (total % tabsPerPage || tabsPerPage))
    );
  };

  // Slice for the current group
  const visibleTabs = partners.slice(startIndex, startIndex + tabsPerPage);
  const activePartner = partners[activeTab];

  return (
    <div className="bg-linear-to-r from-amber-100 to-pink-200 p-4 w-[1024px] rounded-lg">
      {/* Tabs Header */}
      <div className="flex items-center justify-between relative">
        <button
          onClick={handlePrev}
          disabled={startIndex === 0}
          className="p-2 border border-gray-300 rounded-full shadow hover:bg-amber-300 cursor-pointer disabled:opacity-0"
        >
          <ChevronLeft />
        </button>

        <div className="flex justify-between space-x-2 mx-4 w-2/3">
          {visibleTabs.map((uni, index) => {
            const actualIndex = startIndex + index;
            return (
              <button
                key={index}
                onClick={() => {
                  setIsFading(true); // start fade-out
                  setTimeout(() => {
                    setActiveTab(actualIndex); // switch partner AFTER fade-out
                    setIsFading(false); // fade-in
                  }, 300);
                }}
                className={`py-2 px-4 font-medium ${
                  activeTab === actualIndex
                    ? "border-b-4 border-amber-500 text-amber-500 cursor-pointer"
                    : "text-gray-600 hover:text-amber-500 cursor-pointer"
                }`}
              >
                {uni.tabHeader}
              </button>
            );
          })}
        </div>

        <button
          onClick={handleNext}
          disabled={startIndex + tabsPerPage >= total}
          className="p-2 border border-gray-300 rounded-full shadow hover:bg-amber-300 cursor-pointer disabled:opacity-0"
        >
          <ChevronRight />
        </button>
      </div>

      {/* Content Section */}
      <div
        className={`flex flex-col gap-4 mt-4 p-4 border border-gray-300 bg-white rounded-lg transition-opacity duration-300 ${
          isFading ? "opacity-0" : "opacity-100"
        }`}
      >
        <div className="flex flex-row gap-4">
          <div className="flex items-center justify-center w-1/5 h-52 rounded-lg shadow shadow-black p-2">
            <img src={activePartner.image} alt={activePartner.universityName} />
          </div>

          <div className="flex flex-col justify-center w-2/3">
            <div className="font-extrabold text-3xl text-amber-400">
              {activePartner.universityName}
            </div>
            <div className="text-lg">{activePartner.location}</div>

            <ul className="grid grid-cols-2 gap-4 mt-2">
              {activePartner.keyPoint.map((p, i) => (
                <li
                  className="flex flex-row items-center gap-2 p-2 border border-amber-400 rounded-lg"
                  key={i}
                >
                  <div className="w-2 h-2 bg-amber-400 rounded-full"></div>
                  {p}
                </li>
              ))}
            </ul>

            <p className="mt-2 text-sm">{activePartner.intro}</p>
          </div>
        </div>

        <div className="flex flex-col gap-4 shadow shadow-black p-4 rounded-lg">
          <div className="font-bold text-xl text-amber-400">
            Popular Courses
          </div>
          <div className="grid grid-cols-4 gap-4">
            <div className="border border-amber-400 rounded-lg p-2">
              <p>Course 1</p>
            </div>
            <div className="border border-amber-400 rounded-lg p-2">
              <p>Course 1</p>
            </div>
            <div className="border border-amber-400 rounded-lg p-2">
              <p>Course 1</p>
            </div>
            <div className="border border-amber-400 rounded-lg p-2">
              <p>Course 1</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
